module.exports = new __parcel__URL__("tiger.2ba2da26.svg").toString();